import React from "react";
import Radium from "radium";
import EventListener from "react-event-listener";
import IframeResizer from "react-iframe-resizer-super";

import { RaisedButton, Checkbox } from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";
import UserStore from "../stores/UserStore";

import AnalyticsHeader from "./partials/analytics-header.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import GenericAnalyticsTable from "./partials/generic-analytics-table.jsx";

import moment from "moment";
import twix from "twix";

import * as util from "../util";

class StreamingAnalytics extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isRefreshing: false, useV2: false };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  static getStores() {
    return [EventBucketStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getSalesAnalytics: AnalyticsStore.getSalesAnalytics,
      isFetching: AnalyticsStore.getState().isFetching
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props, true);
  }

  componentWillReceiveProps(newProps, force = false) {
    if (
      force === true ||
      newProps.params.eventBucketId !== this.props.params.eventBucketId
    ) {
      EventBucketActions.fetchOne.defer(newProps.params.eventBucketId);
    }
  }

  getStyles() {
    return {};
  }

  render() {
    const styles = this.getStyles(),
      { eventBucketId } = this.props.params,
      eventBucket = this.props.getEventBucketById(eventBucketId);

    if (!eventBucket) {
      return <WorkingIndicator fullPage={true} />;
    }

    const useV2 =
      this.state.useV2 ||
      eventBucket.frontend_config.streaming_analytics_use_v2;
    const path = useV2 ? "admin/analytics_v2" : "admin/analytics";
    const destination = `${process.env.WATCH_SITE_ROOT}${path}?data=${btoa(
      JSON.stringify({
        event_bucket_id: eventBucketId,
        ...UserStore.getCredentials()
      })
    )}`;

    return (
      <div>
        <AnalyticsHeader
          eventBucket={eventBucket}
          allEventBuckets={this.props.getEventBuckets()}
          label="streaming analytics"
          subpath="streaming"
          query={this.props.location.query}
          onRefresh={() => {
            this.setState({ isRefreshing: true }, () => {
              setTimeout(() => this.setState({ isRefreshing: false }), 100);
            });
          }}
          isRefreshing={this.props.isFetching}
        />

        {UserStore.isGod() ? (
          <div>
            <Checkbox
              label="[God only] Use V2"
              checked={useV2}
              onCheck={(e, checked) => this.setState({ useV2: checked })}
              style={{ marginBottom: 10 }}
            />
          </div>
        ) : null}

        <div style={{ position: "relative" }}>
          <IframeResizer
            style={{
              width: "1px",
              minWidth: "100%",
              marginTop: "1em",
              border: "none"
            }}
            src={this.state.isRefreshing ? "" : destination}
          />
        </div>
      </div>
    );
  }
}

export default Radium(connectToStores(StreamingAnalytics));



// WEBPACK FOOTER //
// ./src/app/components/streaming-analytics.jsx